import React from "react";
import { useMediaQuery } from "@mui/system";
import { Grid } from "@mui/material";
import { FunctionField, Labeled, NumberField, ReferenceField, TextField } from "react-admin";
import { settings } from "app";
import { StaffRequestStatus, WeekDaysChoices } from "utils/choices";
import { administrationRequests } from "api/administrationApi";
import { accountRequests } from "api/accountApi";
import { employeeRequests } from "api/employeeApi";
import { SectionTitle } from "features/SectionTitle";

const SubstitutionRequestsDetails = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        title="Данни за заявката"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Дисциплина">
            <ReferenceField
              source="classDisciplineId"
              reference={administrationRequests.getDisciplinesSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Тип занятие">
            <ReferenceField
              source="classTypeId"
              reference={administrationRequests.getRoomClassTypesSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Седмица">
            <NumberField source="weekNumber" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Ден от седмицата">
            <FunctionField render={rec => WeekDaysChoices?.find(x => x.id === rec.classWeekDay)?.name} />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Дата на занятието">
            <TextField source="classDateFormatted" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Час на занятието">
            <FunctionField render={rec => `${rec.classStartTime} - ${rec.classEndTime}`} />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Постоянен преподавател">
            <ReferenceField
              source="permanentEmployeeId"
              reference={employeeRequests.getEmployeesSelect()}
            >
              <FunctionField
                render={rec =>
                  rec.secondName
                    ? `${rec.firstName}  ${rec.secondName} ${rec.lastName}`
                    : `${rec.firstName} ${rec.lastName}`
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Заместващ преподавател">
            <ReferenceField
              source="substituteEmployeeId"
              reference={employeeRequests.getEmployeesSelect()}
            >
              <FunctionField
                render={rec =>
                  rec.secondName
                    ? `${rec.firstName}  ${rec.secondName} ${rec.lastName}`
                    : `${rec.firstName} ${rec.lastName}`
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Създаден от">
            <ReferenceField
              source="staffRequest.createdByUserId"
              reference={accountRequests.getUsersSelect()}
            >
              <FunctionField
                render={rec =>
                  rec.secondName
                    ? `${rec.firstName}  ${rec.secondName} ${rec.lastName}`
                    : `${rec.firstName} ${rec.lastName}`
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Създаден на">
            <FunctionField
              render={rec =>
                rec?.staffRequest?.createdOn ? new Date(rec.staffRequest.createdOn).toLocaleString("bg-BG") : "-"
              }
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Статус">
            <FunctionField render={rec => StaffRequestStatus?.find(x => x.id === rec?.staffRequest?.status)?.name} />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default SubstitutionRequestsDetails;
